export const state = {
  	// list of instruments we're interestd in   
  USER_OTP: [],
  USER_WATCH_LIST: [],
  SAVE_USER_WATCH_LIST: [],
  UPDATE_USER_WATCH_LIST: [],
  ALL_MARKET_ISINS: [],
  ALL_COUNTRIES: [],
  TRADE_IDEAS_LIST: [],
  ISINS_TRADE_IDEAS_LIST: [],
  TRADE_IDEAS_DETAIL: [],
  CALENDAR_EVENTS_LIST: [],
  THEMATIC_INVEST_LIST: [],
  CATEGORIES: [],
  ARTICELS: [],
  COMPLAINTS : {}
}


// WEBPACK FOOTER //
// ./src/plugins/finView/provider/candle-history/store-addons/state.js